import {
  Component,
  EventEmitter,
  Input,
  OnChanges,
  OnInit,
  Output,
  SimpleChanges,
} from '@angular/core'
import {
  FormBuilder,
  FormGroup,
  FormsModule,
  ReactiveFormsModule,
  Validators,
} from '@angular/forms'
import { MatButton, MatIconButton } from '@angular/material/button'
import { MatProgressSpinner } from '@angular/material/progress-spinner'
import { SnackbarCustomService } from '../../../../shared/components/snackbar/snackbar-custom.service'
import {
  ErrorRequestModel,
  ResponseRequestModel,
} from '../../../../core/models/response.model'
import { MatInputModule } from '@angular/material/input'
import { MatOption } from '@angular/material/core'
import { MatSelect } from '@angular/material/select'
import { MatIcon } from '@angular/material/icon'
import { DocumentTypeService } from '../../../../core/services/document/document-type/document-type.service'
import { PersonDocumentService } from '../../../../core/services/person/person-document/person-document.service'
import {
  CreatePersonDocumentModel,
  EditPersonDocumentModel,
} from '../../../../core/models/person-document.model'

@Component({
  selector: 'driver-upload-create-form',
  imports: [
    FormsModule,
    MatButton,
    MatProgressSpinner,
    ReactiveFormsModule,
    MatInputModule,
    MatOption,
    MatSelect,
    MatIcon,
    MatIconButton,
  ],
  templateUrl: './driver-upload-create-form.component.html',
  styleUrl: './driver-upload-create-form.component.scss',
  providers: [DocumentTypeService, PersonDocumentService],
  standalone: true,
})
export class DriverUploadCreateFormComponent implements OnInit, OnChanges {
  constructor(
    private formBuilder: FormBuilder,
    private snackbar: SnackbarCustomService,
    private documentTypeService: DocumentTypeService,
    private personDocumentService: PersonDocumentService,
  ) {}

  form: FormGroup = new FormGroup({})
  loading: boolean = false

  @Output() response = new EventEmitter()
  @Input() editItem: any = {}
  @Input() personId: number = 0

  listType: any[] = []
  file: File | null = null
  allowedTypes = []

  ngOnInit(): void {
    this.getListType()
    this.createForm()
  }

  ngOnChanges(changes: SimpleChanges) {
    if (changes['editItem']) {
      this.treatmentItem()
    }
  }

  private treatmentItem() {
    if (this.checkEdit()) {
      this.resetForm()
      this.fillForm()
    }
  }

  getListType() {
    this.documentTypeService.listDocumentType().subscribe({
      next: (response: ResponseRequestModel) => {
        this.listType = response.data
      },
      error: (err: ResponseRequestModel) => {
        console.error(err)
      },
      complete: () => {},
    })
  }

  checkEdit() {
    if (this.editItem) {
      if (this.editItem.idCreate) {
        return true
      } else {
        return false
      }
    } else {
      return false
    }
  }

  fillForm() {
    this.file = this.editItem.Arquivo
    this.form.get('description')?.setValue(this.editItem.Descricao)
    this.form.get('typeDocument')?.setValue(this.editItem.TipoDocId)
    if (this.file) {
      this.form.get('file')?.setValue(this.file.name)
    } else {
      this.form.get('file')?.setValue('')
    }
  }

  resetForm() {
    this.form.reset()
    this.file = null
  }

  createForm(): void {
    this.form = this.formBuilder.group({
      description: ['', [Validators.required]],
      typeDocument: ['', [Validators.required]],
      file: ['', [Validators.required]],
    })
  }

  createFile() {
    this.loading = true
    const model = this.createModel()
    this.personDocumentService.uploadPersonDocument(model).subscribe({
      next: (response: any) => {
        this.snackbar.success(response.message)
        this.response.emit({ refresh: true, clear: true })
        this.resetForm()
        this.loading = false
      },
      error: (err: ErrorRequestModel) => {
        this.loading = false
        this.snackbar.errorRequest(err)
      },
      complete: () => {
        this.loading = false
      },
    })
  }

  editFile() {
    this.loading = true
    const model = this.createModel(true)
    this.personDocumentService.editPersonDocument(model).subscribe({
      next: (response: any) => {
        this.snackbar.success(response.message)
        this.response.emit({ refresh: true, clear: true })
        this.resetForm()
        this.loading = false
      },
      error: (err: ErrorRequestModel) => {
        this.loading = false
        this.snackbar.errorRequest(err)
      },
      complete: () => {
        this.loading = false
      },
    })
  }

  cancel() {
    this.response.emit({ action: 'cancel' })
    this.resetForm()
    this.file = null
  }

  createModel(edit: boolean = false) {
    if (edit) {
      const model = new EditPersonDocumentModel()
      model.Descricao = this.form.get('description')!.value ?? ''
      model.id = this.editItem.id
      model.PessoaId = this.personId
      model.TipoDocId = this.form.get('typeDocument')!.value ?? ''
      model.Arquivo = this.file

      return model.toFormData()
    } else {
      const model = new CreatePersonDocumentModel()
      model.Descricao = this.form.get('description')!.value ?? ''
      model.PessoaId = this.personId
      model.TipoDocId = this.form.get('typeDocument')!.value ?? ''
      model.Arquivo = this.file

      return model.toFormData()
    }
  }

  onFileSelected(event: Event): void {
    const input = event.target as HTMLInputElement
    if (input.files && input.files.length > 0) {
      this.file = input.files[0]
      this.form.get('file')?.setValue(this.file.name)
    }
  }
  getAllowedTypes() {
    return this.allowedTypes.map((item) => `.${item}`).join(', ')
  }
}
